import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { newFormSchema, uiSchema } from './Schema';

export default class NewForm extends PureComponent {
  onSubmit = ({ formData }) => {
    this.props.onCreate(formData);
  };

  render() {
    const { fetching, form } = this.props;

    return (
      <div className="dealer-list-container">
        <Form
          schema={newFormSchema}
          uiSchema={uiSchema}
          formData={form}
          onSubmit={this.onSubmit}
        >
          <Button
            bsClass="btn btn-primary btn-large"
            disabled={fetching}
            type="submit"
          >
            Submit
          </Button>
        </Form>
      </div>
    );
  }
}

NewForm.propTypes = {
  fetching: PropTypes.bool,
  form: PropTypes.object,
  onCreate: PropTypes.func,
};
